import { Card, CardContent } from "@/components/ui/card";
import { fmtDate } from "./utils";

function Field({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="text-sm font-medium">{value || "—"}</div>
    </div>
  );
}

/** Read-only patient identity tab. */
export default function PacienteTab({ patient }) {
  return (
    <Card><CardContent className="p-6 grid grid-cols-1 md:grid-cols-3 gap-5">
      <Field label="Nome" value={patient?.full_name} />
      <Field label="CNS" value={patient?.cns} />
      <Field label="Data de nascimento" value={fmtDate(patient?.birth_date)} />
      <Field label="Sexo" value={patient?.sex} />
      <Field label="Mãe" value={patient?.mother_name} />
      <Field label="Telefone" value={patient?.phone} />
    </CardContent></Card>
  );
}
